import { AxiosErrorHandler } from 'ui';
import type { TransactionResultParams } from 'features/transactions';
import { GivingDetailSkeleton } from '../components';
import { usePublicGivingQuery } from '../queries';
import { PublicGivingContent } from './public-giving-content';

type P = {
  giveTransaction: TransactionResultParams;
  givingId: string;
  paymentRedirectUrl: string;
};

const PublicGiving = ({ giveTransaction, givingId, paymentRedirectUrl }: P) => {
  const {
    data: givingContentObject,
    error,
    isLoading: isContentObjectLoading,
  } = usePublicGivingQuery({ id: givingId, options: { throwOnError: false } });

  return (
    <AxiosErrorHandler error={error}>
      {isContentObjectLoading || !givingContentObject ? (
        <GivingDetailSkeleton />
      ) : (
        <PublicGivingContent
          giveTransaction={giveTransaction}
          givingContentObject={givingContentObject}
          paymentRedirectUrl={paymentRedirectUrl}
        />
      )}
    </AxiosErrorHandler>
  );
};

export default PublicGiving;
